// extracted by mini-css-extract-plugin
export default {"container":"style_container__IiWr3","content":"style_content__1-hjx","newsBox":"style_newsBox__ugduv","description":"style_description__IHfhN"};